import React from "react";
import { AGENTS } from "../tv/FloorAvatar";

export const BRAINS = ["scott", "jimmy", "funda", "prakash", "crams", "london", "tariq", "genie"];
export const TV_BRAINS = ["scott", "minyo", ...BRAINS.slice(1)];
export const SHORT = { scott: "Scott", minyo: "Minyo", jimmy: "Jimmy", funda: "Funda", prakash: "Prakash", crams: "Crams", london: "London", tariq: "Tariq", genie: "Genie" };

const hueOf = (hex) => {
  const [r, g, b] = [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16) / 255);
  const mx = Math.max(r, g, b), mn = Math.min(r, g, b), d = mx - mn;
  if (!d) return 0;
  const h = mx === r ? ((g - b) / d) % 6 : mx === g ? (b - r) / d + 2 : (r - g) / d + 4;
  return (h * 60 + 360) % 360;
};

export const brainColor = (agent) => (AGENTS[agent === "debate" ? "london" : agent] || {}).color || "#00F0FF";

export const AgentBrain = ({ agent, size = 48, active = false, dim = false }) => {
  const c = brainColor(agent);
  return (
    <span className="relative inline-block rounded-full overflow-hidden shrink-0" data-testid={`agent-brain-${agent}`}
      style={{ width: size, height: size, border: `1.5px solid ${c}${active ? "" : "66"}`, boxShadow: active ? `0 0 22px ${c}` : "none",
        opacity: dim ? 0.38 : 1, transition: "opacity .4s, box-shadow .4s" }}>
      <img src="/ponytail-brain.jpg" alt={`${SHORT[agent] || agent} brain`} className={`w-full h-full object-cover ${active ? "animate-pulse" : ""}`}
        style={{ filter: `hue-rotate(${Math.round(hueOf(c) - 290)}deg) saturate(${dim ? 0.4 : 1.25})` }} />
    </span>
  );
};
